angular.module('picmonicng').factory('WorkflowService', [
  '$q',
  '$filter',
  'WorkflowResource',
  'WorkflowTasksResource',
  'Users',
  'UserService',
  'PermissionsService',
  '$modal',
  'toaster',
  'MarketOptionsConfig',
  function (
    $q,
    $filter,
    WorkflowResource,
    WorkflowTasksResource,
    Users,
    UserService,
    PermissionsService,
    $modal,
    toaster,
    MarketOptionsConfig
  ) {
    var WorkflowService = {
      sidebarOpen: true,
      closingAction: false,
      closingWorkflow: false,
      workflow: {},
      myTasks: [],
      myTimeSpent: 0,
      users: [],
      loading: false,
      toggleSidebar: function () {
        this.sidebarOpen = !this.sidebarOpen;
      },
      orderStates: function () {
        var self = this;
        var s = self.workflow.states;
        var ordered = $filter('orderBy')(
          $filter('filter')(s, function (v) {
            return !v.dependencies.length || v.cycle < self.workflow.current_cycle;
          }),
          'cycle'
        );
        var orderedids = ordered.map(function (v) {
          return v.workflow_state_id;
        });
        var unordered = $filter('filter')(s, function (v) {
          return v.dependencies.length;
        });
        var x = 0;
        var i = 0;
        while (unordered.length && i < 1000) {
          if (
            unordered[x].dependencies.filter(function (d) {
              return orderedids.indexOf(d.workflow_state_id) > -1;
            }).length === unordered[x].dependencies.length
          ) {
            var t = unordered.splice(x, 1);
            ordered.push(t[0]);
            orderedids.push(t[0].workflow_state_id);
            x = x % unordered.length;
          } else {
            x = (x + 1) % unordered.length;
          }
          i++;
        }
        self.workflow.states = ordered;
      },
      getPicmonicWorkflow: function (card_id) {
        var self = this;
        self.loading = true;

        return WorkflowResource.get({ card_id: card_id })
          .$promise.then(function (data) {
            self.workflow = data;
            self.orderStates();

            self.current_card_id = self.workflow.resource.card_id || self.workflow.resource.data.card.card_id;
            self.original_card_id =
              self.workflow.cloned_from_resource_id ||
              (self.workflow.resource.data ? self.workflow.resource.data.card.card_id : null);
          })
          .finally(function () {
            self.aggregateData();
            self.loading = false;
          });
      },
      getWorkflowForType: function (type, type_id) {
        var self = this;
        self.loading = true;

        return WorkflowResource.getType({ type: type, type_id: type_id })
          .$promise.then(function (data) {
            self.workflow = data;
            self.current_card_id = self.workflow.resource.card_id || self.workflow.resource.data.card.card_id;
            self.original_card_id =
              self.workflow.cloned_from_resource_id ||
              (self.workflow.resource.data ? self.workflow.resource.data.card.card_id : null);
          })
          .finally(function () {
            self.aggregateData();
            self.loading = false;
          });
      },
      updateWorkflow: function () {
        var self = this;
        self.loading = true;

        return WorkflowResource.get({ workflow_id: this.workflow.workflow_id })
          .$promise.then(function (data) {
            self.workflow = data;
            self.orderStates();
            self.current_card_id = self.workflow.resource.card_id || self.workflow.resource.data.card.card_id;
            self.original_card_id =
              self.workflow.cloned_from_resource_id ||
              (self.workflow.resource.data ? self.workflow.resource.data.card.card_id : null);
          })
          .finally(function () {
            self.aggregateData();
            self.loading = false;
          });
      },
      getUserNameFromId: function (user_id) {
        var user = $filter('filter')(this.users, { user_id: parseInt(user_id, 10) }, true);
        if (user[0]) {
          return user[0].first_name + ' ' + user[0].last_name;
        }
      },
      getAssignToName: function (user) {
        var name = user.first_name + ' ' + user.last_name;
        var roles = $filter('filter')(this.workflow.roles, {
          pivot: { user_id: user.user_id },
        });
        var role_names = [];
        for (var x in roles) {
          role_names.push(roles[x].name);
        }
        name += role_names.length ? ' (' + role_names.join() + ')' : '';
        return name;
      },
      saveTask: function (task) {
        var self = this,
          promise;
        self.loading = true;

        task.time_spent = task.time_spent_hours * 60 + parseInt(task.time_spent_mins, 10) || 0;

        if (task.workflow_task_id) {
          promise = WorkflowTasksResource.update(task).$promise;
        } else {
          task.workflow_id = this.workflow.workflow_id;
          promise = WorkflowTasksResource.save(task).$promise;

          promise.then(function (data) {
            var state = $filter('filter')(self.workflow.states, { workflow_state_id: data.workflow_state_id }, true)[0];
            state.tasks.push(data);
          });
        }

        promise
          .then(function () {
            self.aggregateData();
            self.updateWorkflow();
          })
          .finally(function () {
            self.loading = false;
          });

        return promise;
      },
      completeTask: function (task) {
        var self = this;
        if (!task.completed_at) {
          task.completed_at = Math.floor(new Date().getTime() / 1000);
        }
      },
      deleteTask: function (task, state) {
        var self = this;
        state.tasks.splice(state.tasks.indexOf(task), 1);
        task.workflow_id = this.workflow.workflow_id;
        var promise = WorkflowTasksResource.delete(task)
          .$promise.then(function () {
            self.aggregateData();
            self.updateWorkflow();
          })
          .finally(function () {
            self.loading = false;
          });

        return promise;
      },
      aggregateData: function () {
        var self = this;

        self.myTasks = [];
        self.myTimeSpent = 0;

        for (var a in self.workflow.states) {
          var state = self.workflow.states[a];
          for (var b in state.tasks) {
            var task = state.tasks[b];

            if (task.assignee_id == parseInt(UserService.user.user_id, 10)) {
              self.myTimeSpent += task.time_spent;
              self.myTasks.push(task);
            }
          }
        }
      },
      sendBackForRework: function () {
        var self = this;
        var modal = $modal.open({
          templateUrl: '/templates/modals/workflow-send-back.html',
          controller: ['$scope', function ($scope) {}],
        });

        modal.result.then(function (value) {
          WorkflowResource.sendBack(
            {
              workflow_id: self.workflow.workflow_id,
              reason: value,
            },
            function () {
              toaster.success('', 'Card has been sent back to be reworked');
              window.open('/workflow/' + self.workflow.workflow_id + '/edit?addStates=true');
            }
          );
        });
      },
      hasOpenTask: function (user_id) {
        var self = this;
        if (!self.workflow.states) {
          return false;
        }
        return self.workflow.states.reduce(function (open, item) {
          if (!item.is_active) {
            return open;
          }
          return (
            open ||
            item.tasks.reduce(function (opent, itemt) {
              if (!itemt.completed_at && itemt.assignee_id == user_id) {
                return true;
              }
              return opent;
            }, false)
          );
        }, false);
      },
      mergeCard: function (workflow) {
        var self = this;
        if (confirm('Are you sure you want to merge this card with the original?')) {
          self.validate(workflow).then(function () {
            self.addReleaseNotes(workflow, '$merge');
          });
        }
      },

      versionCard: function (workflow) {
        var self = this;
        if (confirm('Are you sure you want to version this card?')) {
          self.validate(workflow).then(function () {
            self.addReleaseNotes(workflow, '$version');
          });
        }
      },

      publishCard: function (workflow) {
        var self = this;
        self.validate(workflow).then(function () {
          var modal = $modal.open({
            templateUrl: '/templates/picmonic-workflow/modals/select-market.html',
            controller: [
              '$scope',
              function ($scope) {
                $scope.MarketOptionsConfig = MarketOptionsConfig;
                $scope.workflow = workflow;
                $scope.markets = {};
                $scope.markets[workflow.resource.primary_market_id] = true;
                $scope.publish = function () {
                  var markets = [];
                  for (var x in $scope.markets) {
                    if ($scope.markets[x]) {
                      markets.push(x);
                    }
                  }
                  $scope.$close(markets);
                };
              },
            ],
          });
          modal.result.then(function (data) {
            self.closingWorkflow = true;
            self.closingAction = 'Publishing';
            workflow.markets = data;
            workflow
              .$publish(function () {
                toaster.success('', 'Card has been published!');
                window.location = '/learn/' + workflow.released_id;
              })
              .finally(function () {
                self.closingWorkflow = false;
              });
          });
        });
      },

      deleteWorkflow: function (workflow) {
        var self = this;
        if (confirm('Are you sure you want to delete this workflow?')) {
          workflow.$delete();
        }
      },

      validate: function (workflow) {
        var self = this;
        return $q(function (resolve, reject) {
          self.closingWorkflow = true;
          self.closingAction = 'validating';
          workflow
            .$validate()
            .then(
              function () {
                resolve();
              },
              function (data) {
                var modal = $modal.open({
                  templateUrl: '/templates/picmonic-workflow/modals/validation-errors.html',
                  controller: [
                    '$scope',
                    function ($scope) {
                      $scope.errors = data.data;
                    },
                  ],
                });
                modal.result.then(
                  function () {
                    resolve();
                  },
                  function () {
                    reject();
                  }
                );
              }
            )
            .finally(function () {
              self.closingWorkflow = false;
            });
        });
      },

      stateSorter: function (a, b, c, d) {
        console.log(a, b, c, d);
        return 0;
      },

      addReleaseNotes: function (workflow, action) {
        var self = this;
        var modal = $modal.open({
          templateUrl: '/templates/picmonic-workflow/modals/release-notes.html',
          controller: ['$scope', function ($scope) {}],
        });
        modal.result.then(function (release_notes) {
          workflow.release_notes = release_notes;
          self.closingWorkflow = true;
          self.closingAction = action.substring(1);
          workflow[action](function () {
            var msg;
            switch (action) {
              case '$merge':
                msg = 'Card has been merged!';
                break;
              case '$version':
                msg = 'Card has been versioned!';
                break;
            }
            toaster.success('', msg);
            window.location = '/learn/' + workflow.released_id;
          }).finally(function () {
            self.closingWorkflow = false;
          });
        });
      },
    };

    (function () {
      if (UserService.user.user_id) {
        PermissionsService.roles.$promise.then(function () {
          if (PermissionsService.hasRole('workflow').result) {
            Users.query({ workflow: true }).$promise.then(
              function (data) {
                WorkflowService.users = data;
              },
              function () {
                WorkflowService.users = {};
              }
            );
          } else {
            WorkflowService.users = {};
          }
        });
      } else {
        WorkflowService.users = {};
      }
    })();

    return WorkflowService;
  },
]);
